import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const PopupMenuGroup = ({ children, className, ...props }) => {
  const cn = useClassNames(
    () => ['border-b', 'border-slate-200', 'last:border-b-0', className],
    [className],
  );
  return (
    <ul className={cn} {...props}>
      {children}
    </ul>
  );
};

PopupMenuGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default PopupMenuGroup;
